import { useTranslation } from '@hooks/useTranslation';
import React from 'react';

const PaymentLoader = () => {

  const { translate } = useTranslation();
  
  return (
    <article>
      <div className="StepCheckout">
        <div className="Selected"></div>
        <div className="Selected"></div>
        <div className="Selected"></div>
        <div className="Selected"></div>
      </div>
      <div className="FontSmall"><br /><br /><br /><br /><br /><br /><br /><br />
        <div className="payment-loader-content">
          <div className="payment-loader-spinner"></div>
          <h6>{translate('checkout.processing_payment')}</h6>
          <h6>{translate('checkout.dont_close_window')}</h6>
        </div>
      </div><br /><br /><br /><br /><br /><br /><br />
    </article>
  );
};

export default PaymentLoader;

